/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/no-onchange */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import FieldStyle from '../fields.module.scss';
import GetWildLifeInfo from '../../../modules/services/GetWildLifeInfo';


class WildLifeSpecies extends Component {
  constructor(props) {
    super(props);
    const { isRequired, answer, updateFieldErrors } = this.props;
    this.state = {
      wildLifeSpices: []
    };

    if (isRequired && !answer) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  componentDidMount() {
    const { answer, isRequired, handleFieldErrorChanged, fieldId, updateFieldErrors } = this.props;
    if (Object.keys(answer)?.length !== 2
    || Object.keys(answer)?.some(ele => answer[ele] === ''|| answer[ele] === undefined || answer[ele]?.trim() === '')) {
    let updatedErrors = [];
    handleFieldErrorChanged(fieldId, isRequired);
    if (isRequired) {
      updatedErrors = [
        ...updatedErrors,
        'pulpoforms.errors.not_blank'
      ];
    }
    updateFieldErrors(updatedErrors);
    }
  }

  async componentDidUpdate() {
    const { wildLifeSpices } = this.state;

    if (wildLifeSpices?.length === 0) {
      const temp = await GetWildLifeInfo.getWildLifeInfo();
      this.setState({ wildLifeSpices: temp?.data || [] });
    }
  }

  handleAnswerChanged(value, fieldId, field) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors, answer
    } = this.props;
    let updatedErrors = [];
    if (field === 'type') {
      handleValueChange({ type: value }, fieldId);
      handleFieldErrorChanged(fieldId, isRequired);
      if (isRequired) {
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.not_blank'
        ];
      }
    } else if (field === 'species') {
      handleValueChange({ ...answer, species: value }, fieldId);
      let temp = { ...answer, [field]: value };
      if (Object.keys(temp)?.length !== 2 || Object.keys(temp)?.some(ele => temp[ele] === ''|| temp[ele] === undefined || temp[ele]?.trim() === '')) {
        handleFieldErrorChanged(fieldId, isRequired);
        if (isRequired) {
          updatedErrors = [
            ...updatedErrors,
            'pulpoforms.errors.not_blank'
          ];
        }
      } else {
        handleFieldErrorChanged(fieldId, false);
      }
    }
    updateFieldErrors(updatedErrors);
  }

  render() {
    const { answer, disabled, fieldId, placeholder, defaultOption } = this.props;
    const { wildLifeSpices } = this.state;

    let tempSpecies = wildLifeSpices?.filter(ele => ele?.Type === answer?.type);

    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #E6EAEE', paddingTop: '1.5rem' }}>
        <div style={{ width: '40%' }}>
          <span className={FieldStyle.title}>
            <FormattedMessage
              id="wildlife.form.type"
              defaultMessage="Wildlife Type"
            />
          </span>
        <select
          value={answer?.type}
          onChange={e => this.handleAnswerChanged(e.target.value, fieldId, 'type')}
          name={`select-field-${fieldId}`}
          className="pulpo-dropdown"
          disabled={disabled}
          placeholder={placeholder}
          style={{ width: '100%' }}
          title={answer?.type || ''}
        >
          <option key="default" value="">
            {defaultOption}
          </option>
          {wildLifeSpices?.map(option => (
            <option key={option.id} value={option.Type} title={option.Type}>
              {option?.Type?.length > 40 ? `${option.Type.substring(0, 40)}...` : option.Type}
            </option>
          ))}
        </select>
        </div>
        <div style={{ width: '40%' }}>
          <span className={FieldStyle.title}>
            <FormattedMessage
              id="wildlife.form.species"
              defaultMessage="Wildlife Species"
            />
          </span>
          <select
            value={answer?.species}
            onChange={e => this.handleAnswerChanged(e.target.value, fieldId, 'species')}
            name={`select-field-${fieldId}`}
            className="pulpo-dropdown"
            disabled={disabled}
            placeholder={placeholder}
            style={{ width: '100%' }}
            title={answer?.species || ''}
          >
            <option key="default" value="">
              {defaultOption}
            </option>
            {(tempSpecies?.[0]?.Species ?? [])?.map(option => (
              <option key={option?.name} value={option.name} title={option.name}>
                {option?.name?.length > 40 ? `${option.name.substring(0, 40)}...` : option.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}


WildLifeSpecies.defaultProps = {
  answer: ''
};

WildLifeSpecies.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired
};


export default connect()(WildLifeSpecies);
